import { useState } from 'react';
import AudioPlayer from './AudioPlayer';
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { ImCross } from 'react-icons/im';
import { motion } from 'framer-motion'
// import AudioPlayer from './AudioPlyer';

function LogoModal({ icons = false, setIcons, audio, handleFullScreen, progress, dispatch, isNavShowing, setIsNavShowing, garbage = false, setShowGarbageIcons, isRaining = false, setIsLeftPaused = false }) {
    const [isPlaying, setIsPlaying] = useState(true);
    const totalBlocks = 12; // Total number of segments
    const filledBlocks = Math.round(progress * totalBlocks); // Scale progress (0 to 1) to total blocks



    return (
        <div className='  z-[9999]' >

            {/* HAMBURGER MENU */}
            <div className='absolute  top-0 left-0  w-full  flex justify-end   lg:hidden z-50 '>

                {!isNavShowing ? (<GiHamburgerMenu className='text-xl  bg-white p-4 mt-4 mr-4 size-16 rounded-xl cursor-pointer hover:bg-[#5cd6d6] hover:text-white transition-all z-50'
                    onClick={() => {
                        setIsNavShowing(prev => !prev)
                        dispatch({ type: 'hideAll' });

                        if (icons) {
                            setIcons(false)
                        }
                        if (garbage) {
                            setShowGarbageIcons(false)
                        }
                    }}
                />)
                    :
                    (<ImCross className='text-xl  bg-white p-4 mt-4 mr-4 size-16 rounded-xl cursor-pointer hover:bg-[#5cd6d6] hover:text-white transition-all z-50'
                        onClick={() => {
                            setIsNavShowing(prev => !prev)
                            dispatch({ type: 'resetAll' })
                            if (icons) {
                                setIcons(true)
                            }
                            if (garbage) {
                                setShowGarbageIcons(true)
                            }
                        }} />
                    )
                }
                {/* NAVBAR */}

                {
                    isNavShowing &&
                    (
                        <motion.div
                            initial={{
                                x: 1000
                            }}
                            animate={{
                                x: 0
                            }}
                            className='w-full smallSM:w-1/2 bg-black/45 backdrop-blur-md h-screen right-0 top-0 flex flex-col justify-between fixed '>

                            <div className='flex justify-center flex-col gap-4 p-2 pt-28'>
                                <Link to={'/'} className='hover:bg-[#5cd6d6] cursor-pointer p-2 bg-white w-full flex items-center gap-4 text-[#33cccccc] hover:text-white rounded-xl'>
                                    <span >
                                        <img src={'/360-Lernwelt/logoModal/home.gif'} alt="VR logo" className='size-12 object-cover' />
                                    </span>
                                    <span className='text-xl '>Go To Home</span>
                                </Link>

                                {/* Play/Pause button for audio */}
                                <div
                                    className='hover:bg-[#5cd6d6]  cursor-pointer p-2 bg-white w-full flex items-center gap-4 text-[#33cccccc] hover:text-white rounded-xl'
                                    onClick={() => {
                                        setIsPlaying(prev => !prev)
                                        setIsLeftPaused(prev => !prev)

                                    }}
                                >
                                    <img
                                        src={isPlaying ? '/360-Lernwelt/logoModal/sound.gif' : '/360-Lernwelt/logoModal/no-audio.gif'}
                                        alt="audio control"
                                        className='size-12 object-cover'
                                    />
                                    <span className='text-xl '>Audio Control</span>
                                </div>

                                <div className='hover:bg-[#5cd6d6]  cursor-pointer p-2 bg-white w-full flex items-center gap-4 text-[#33cccccc] hover:text-white rounded-xl' onClick={handleFullScreen}>
                                    <img src={'/360-Lernwelt/logoModal/zoom.gif'} alt="fullscreen logo" className='size-12 object-cover' />
                                    <span className='text-xl '>Full Screen</span>
                                </div>
                            </div>

                            <div className='z-50'>


                                {progress && <div className="progress-container-mobile">
                                    <div className="progress-bar-mobile">
                                        {Array.from({ length: totalBlocks }).map((_, index) => (
                                            <div
                                                key={index}
                                                className="progress-block"
                                                style={{
                                                    backgroundColor: index < filledBlocks ? "#0e2a5b" : "#d3d3d3", // Blue for filled, gray for unfilled
                                                    transition: "background-color 0.3s ease-in-out"
                                                }}
                                            />
                                        ))}
                                    </div>
                                    <p className="progress-text font-mullish">WIEVIEL HAST DU BEREITS ENTDECKT?</p>
                                </div>}

                                <img src={'/360-Lernwelt/logoModal/logo.png'} alt='logo' className=' ' />
                            </div>
                        </motion.div>
                    )}



            </div>
            <div className="absolute bottom-0 py-1 left-0 bg-white z-50 w-72 hidden lg:flex flex-col gap-2 rounded-tr-[40px] overflow-hidden   logo-shadow  ">




                {/* Audio player component */}
                <AudioPlayer audio={audio} setIsPlaying={setIsPlaying} isPlaying={isPlaying} />
                {isRaining && (

                    <AudioPlayer
                        volume={1}
                        audio={'/360-Lernwelt/wasser/A/audios/wasserA-bg-audio.mp3'} setIsPlaying={setIsPlaying} isPlaying={isPlaying} />
                )}


                <img src={'/360-Lernwelt/logoModal/logo.png'} alt='logo' className='w-full  pr-2' />


                <div className='flex justify-center items-center gap-4 p-2'>
                    <Link to={'/'} className='hover:bg-gray-200 cursor-pointer p-2'>
                        <span >
                            <img src={'/360-Lernwelt/logoModal/home.gif'} alt="VR logo" className='size-12 object-cover' />
                        </span>
                    </Link>
                    |
                    {/* Play/Pause button for audio */}
                    <span
                        className='hover:bg-gray-200 cursor-pointer p-2'
                        onClick={() => {
                            setIsPlaying(prev => !prev)
                            setIsLeftPaused(prev => !prev)
                        }}
                    >
                        <img
                            src={isPlaying ? '/360-Lernwelt/logoModal/sound.gif' : '/360-Lernwelt/logoModal/no-audio.gif'}
                            alt="audio control"
                            className='size-12 object-cover'
                        />
                    </span>
                    |
                    <span className='hover:bg-gray-200 cursor-pointer p-2' onClick={handleFullScreen}>
                        <img src={'/360-Lernwelt/logoModal/zoom.gif'} alt="fullscreen logo" className='size-12 object-cover' />
                    </span>
                </div>


            </div>
        </div>
    );
}

export default LogoModal;